import axios from "axios"; // 引用axios
import baseConfig from "../api/config";
import {tansParams} from "@/assets/utils/common";
import {handleSessionExpired} from "@/utils/auth";

axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
// 创建axios实例
const service = axios.create({
    baseURL: baseConfig.baseUrl.dev,
    // baseURL: process.env.VUE_APP_BASE_API,
    // 70s：扫码支付后端会为「查不到终态」的支付请求持续查单到 60s 预算耗尽（SCAN_REQUEST_BUDGET_MS），
    // 前端超时必须留出余量，否则后端结论永远到不了页面，收银员看到的是「请求失败」
    timeout: 70000,
});
export const uploadUrl = baseConfig.baseUrl.dev + "/common/upload"; // 图片上传
// 把token写入请求头
service.interceptors.request.use(config => {
    config.headers['Authorization'] = 'Bearer ' + window.sessionStorage.getItem('xtoken') // 让每个请求携带自定义token 请根据实际情况自行修改
    return config
})
service.interceptors.response.use(response => {
    const requestUrl = response.config && response.config.url ? response.config.url : '';
    if (response.data && response.data.code === 401 && !requestUrl.includes('/login')) {
        handleSessionExpired();
        return Promise.reject(new Error('登录状态已失效，请重新登录。'));
    }
    return response;
}, error => {
    if (error.response && error.response.status === 401) {
        handleSessionExpired();
    }
    return Promise.reject(error);
});
//get请求
export function getRequest(url, params = {}) {
    // get请求映射params参数
    let actUrl = url + '?' + tansParams(params);
    url = url.slice(0, -1);
    params = {};
    url = actUrl;
    return new Promise((resolve, reject) => {
        service.get(url, {
                params: params,
            })
            .then((response) => {
                resolve(response);
            })
            .catch((err) => {
                reject(err);
            });
    });
}
//post请求
export function postRequest(url, data = {}) {
    return new Promise((resolve, reject) => {
        service.post(url, data).then(
            (response) => {
                resolve(response.data);
            },
            (err) => {
                reject(err);
            }
        );
    });
}
//put请求
export function putRequest(url, data = {}) {
    return new Promise((resolve, reject) => {
        service.put(url, data).then(
            (response) => {
                resolve(response.data);
            },
            (err) => {
                reject(err);
            }
        );
    });
}
//delete请求
export function deleteRequest(url, data = {}) {
    return new Promise((resolve, reject) => {
        service.delete(url, data).then(
            (response) => {
                resolve(response.data);
            },
            (err) => {
                reject(err);
            }
        );
    });
}
